unit LocationItemType;
{

/* Initail. */

}
interface

uses
  JS,
  SysUtils;

type
  TLocationItemType = class
  private
    fLocationKey: String;
    fName: String;
    fAmount: Word;
    fActive: Boolean;
  public
    property LocationKey: String read fLocationKey;
    property Name: String read fName;
    property Amount: Word read fAmount;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TLocationItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fLocationKey := String(JSObject_Type['locationKey']);
    fName := String(JSObject_Type['name']);
    fAmount := StrToInt(String(JSObject_Type['fAmount']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
